// Google Tag Manager helper for CRA apps
// Usage:
// - Set REACT_APP_GTM_ID in your environment (e.g., GTM-XXXXXXX)
// - initGTM() is called once in index.js
// - trackPageView() is called on route changes

let gtmInitialized = false;

export function initGTM(): void {
  if (typeof window === 'undefined') return;
  const gtmId = import.meta.env.REACT_APP_GTM_ID;
  if (!gtmId || gtmInitialized) return;

  // Setup dataLayer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  // Inject GTM script
  const firstScript = document.getElementsByTagName('script')[0];
  const gtmScript = document.createElement('script');
  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;

  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(gtmScript, firstScript);
  } else {
    document.head.appendChild(gtmScript);
  }

  gtmInitialized = true;
}

export function trackPageView(path?: string): void {
  if (typeof window === 'undefined') return;
  const page_path = path || (window.location && window.location.pathname + window.location.search) || '/';
  const page_location = (typeof window !== 'undefined' && window.location && window.location.href) || '';
  const page_title = (typeof document !== 'undefined' && document.title) || '';

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', { page_path, page_location, page_title });
  } else {
    window.dataLayer.push({ event: 'page_view', page_path, page_location, page_title });
  }
}

export function trackEvent(eventName: string, params: Record<string, any> = {}): void {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  } else if (window.dataLayer) {
    window.dataLayer.push({ event: eventName, ...params });
  }
}
